"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var IconShowMore = function IconShowMore(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#0097FF",
    fillRule: "evenodd",
    d: "M32 8c13.255 0 24 10.745 24 24S45.255 56 32 56 8 45.255 8 32 18.745 8 32 8zm0 2.011c-12.144 0-21.989 9.845-21.989 21.989S19.856 53.989 32 53.989 53.989 44.144 53.989 32 44.144 10.011 32 10.011zm7.58 14.526l.095.087 6.43 6.61a1 1 0 0 1 .155.208l.056.114.008.014c.102.257.101.548-.003.806l-.007.014a1.117 1.117 0 0 1-.128.223l-.086.1-6.476 6.658a.998.998 0 0 1-1.44.005 1.067 1.067 0 0 1-.08-1.381l.085-.1 4.732-4.863-16.627-.041a.991.991 0 0 1-.718-.304 1.05 1.05 0 0 1-.296-.74c.002-.539.4-.985.91-1.043l.112-.006 16.627.04-4.699-4.829a1.067 1.067 0 0 1 .005-1.48 1 1 0 0 1 1.345-.092zm-17.131 6.646c.44.44.447 1.15.02 1.6a1.146 1.146 0 0 1-1.723-1.509c.032-.038.032-.038.057-.064l.008-.008.018-.019a1.146 1.146 0 0 1 1.62 0z"
  }));
};
IconShowMore.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "64",
  height: "64",
  viewBox: "0 0 64 64"
};
var _default = IconShowMore;
exports["default"] = _default;
//# sourceMappingURL=iconShowMore.js.map